import { FacilityBrand, BffBrandType } from '@/gqlConstants';
import { TAGBrand } from '@/types';

/**
 * Converts a TAGBrand enum value to its corresponding FacilityBrand or BffBrandType
 * @param brand - The TAGBrand enum value to convert
 * @returns The corresponding FacilityBrand or BffBrandType value
 *          Returns FacilityBrand.AspenDental as default if no match is found
 */
export function brandThemeToFacilityBrand(brand: TAGBrand): FacilityBrand | BffBrandType {
	switch (brand) {
		case TAGBrand.WellNow:
		case TAGBrand.YouWellNow:
		case TAGBrand.LivWellNow:
			return FacilityBrand.WellNow;
		case TAGBrand.ClearChoice:
		case TAGBrand.LobbyClearChoice:
		case TAGBrand.ConsultClearChoice:
			return FacilityBrand.ClearChoice;
		case TAGBrand.Motto:
		case TAGBrand.TeamTAG:
		case TAGBrand.AspenDental:
			return FacilityBrand.AspenDental;
		case TAGBrand.AZPetVet:
			return BffBrandType.AzPet;
		case TAGBrand.Lovet:
			return BffBrandType.Lovet;
		case TAGBrand.Chapter:
			return BffBrandType.Chapter;
		default:
			return FacilityBrand.AspenDental;
	}
}
